import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { SessionService } from '../session/session.service';
import { SystemConfig } from '../../config/system-config';
import { HistoryTicket } from '../../domain/history-ticket';
import { BalanceService } from '../../balance/balance.service';

@Injectable()
export class TicketHistoryService {

    lastExecutionDate: Date;

    constructor(public sessionService: SessionService,
                public balanceService: BalanceService,
                public http: Http) {
    }

    fetchHistory() {
        let date: Date = new Date();
        if (this.sessionService.punter && (!this.lastExecutionDate || this.lastExecutionDate.getTime() + 10000 < date.getTime())) {
            this.lastExecutionDate = date;

            this.http.get(SystemConfig.Endpoint.TICKET_HISTORY, {headers: new Headers()})
                .subscribe(response => this.sessionService.history = this.map(response.json()));
        }
    }

    map(rawTicketHistory: any): HistoryTicket[] {
        let history: HistoryTicket[] = [];

        rawTicketHistory.forEach(rth => {
            history.push(new HistoryTicket(
                rth.BB1TicketID,
                rth.InDate,
                rth.BingoGameId,
                rth.Won ? 'WON' : (rth.Calculated ? 'LOST' : 'PENDING'),
                rth.SelectedNumbers ? rth.SelectedNumbers : [],
                rth.Stake,
                rth.Profit,
                rth.JackpotWonAmount,
                rth.Drawings,
                rth.Disbursed,
                rth.Calculated,
                rth.Code,
                rth.Number,
                rth.Storno || rth.SuperStorno,
                rth.JackpotCode));

            if(rth.JackpotWonAmount > 0 && this.sessionService.jackpotWonAmount === 0 && this.showJackpot(rth)) {
                this.sessionService.jackpot = rth.JackpotWonAmount;
                this.sessionService.jackpotWonAmount = rth.JackpotWonAmount;
                this.sessionService.showJackpotWon = true;
                const jackpotTickets: number[] = JSON.parse(localStorage.getItem('jackpotTickets'));
                if(!jackpotTickets) {
                  localStorage.setItem('jackpotTickets', JSON.stringify([rth.BB1TicketID]));
                } else {
                  jackpotTickets.push(rth.BB1TicketID);
                  localStorage.setItem('jackpotTickets', JSON.stringify(jackpotTickets));
                }

            }
        });

        history.forEach(ht => {
            if (!ht.storno && !ht.disbursed && ht.calculated && (ht.wonAmount > 0 || ht.jackpotWonAmount > 0)) {
                this.disburse(ht);
            }
        });

        return history;
    }

    public disburse(ht: HistoryTicket) {
        this.http.post(SystemConfig.Endpoint.TICKET_DISBURSE, {
            BB1TicketID: ht.id,
            Code: ht.code,
            Number: ht.number
        }, { headers: new Headers() })
            .subscribe(response => {
                if (response.json().Success) {
                    ht.disbursed = true;
                    this.balanceService.updateBalance();
                }
            });
    }

  private showJackpot(rth: any) {
    var maxDate = new Date();
    maxDate.setHours(maxDate.getHours() - 12);
    const ticketDate = new Date(Date.parse(rth.InDate));

    const ticketIsFresh = ticketDate.getTime() > maxDate.getTime();
    let oldJackpotTickets: number[] = JSON.parse(localStorage.getItem('jackpotTickets'));
    const alreadyDisplayed = oldJackpotTickets && oldJackpotTickets.indexOf(rth.BB1TicketID) > -1;

    return ticketIsFresh && !alreadyDisplayed;
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/ticket-history/ticket-history.service.ts